export default __webpack_public_path__ + "static/media/img-basic-wallet.0eaad5c9.png";